import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'fcp-search',
    templateUrl: './fcp-search.component.html',
    styleUrls: ['./fcp-search.component.less'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FcpSearchComponent
        }
    ],
    standalone: false
})
export class FcpSearchComponent implements ControlValueAccessor {
    @Input() placeholder = '';
    @Input() disabled = false;
    /** @deprecated Use `size` instead */
    @Input() compact = false;
    @Input() size: FcpSearchSizes = FcpSearchSizes.Fluid;
    @Input() prefix = FcpSearchPrefix.Magnifier;
    @Output() searchQueryChange = new EventEmitter<string>();

    public searchQuery = '';
    public sizeEnum = FcpSearchSizes;

    public onTouched = () => {};
    public onChange = (searchQuery: string) => {};

    public writeValue(searchQuery: string): void {
        this.searchQuery = searchQuery;
    }

    public registerOnChange(onChange: any): void {
        this.onChange = onChange;
    }

    public registerOnTouched(onTouched: any): void {
        this.onTouched = onTouched;
    }

    public handleSearchQueryChange(searchQuery: string) {
        this.searchQuery = searchQuery;
        this.searchQueryChange.emit(searchQuery);
        this.onChange(searchQuery);
    }
}

export enum FcpSearchSizes {
    Default = 'default',
    Compact = 'compact',
    Fluid = 'fluid'
}

export enum FcpSearchPrefix {
    None = '',
    Magnifier = 'magnifying-glass'
}
